import { createJWT } from '@dreamstack/crypto'
import type { DocumentDownloadSecretPayload } from './DocumentDownloadSecretPayload.type'

export const getPropstackDocumentViewerSecret = (
  payload: DocumentDownloadSecretPayload
) => {
  return createJWT(payload)
}
